import * as accessibleNames from './attributes/accessible-names';
import * as addGroupItem from './attributes/add-group-item';
import * as animateOnChange from './attributes/animate-on-change';
import * as applicantName from './attributes/applicant-name';
import * as applicationDescription from './attributes/application-description';
import * as applicationTag from './attributes/application-tag';
import * as datePicker from './attributes/date-picker';
import * as deleteGroupItem from './attributes/delete-group-item';
import * as deriveFromSsn from './attributes/derive-from-ssn';
import * as formField from './attributes/form-field';
import * as gotoAnchor from './attributes/goto-anchor';
import * as multiply from './attributes/multiply';
import * as popOverAttribute from './attributes/pop-over';
import * as submitApplication from './attributes/submit-application';
import * as sum from './attributes/sum';
import * as tooltip from './attributes/tooltip';
import * as attachment from './elements/attachment';
import * as attachmentV2 from './elements/attachment-v2';
import * as applicationLink from './elements/application-link';
import * as bankidSignature from './elements/bankid-signature';
import * as popOverElement from './elements/pop-over';
import * as textareaex from './elements/textareaex';
import * as signatureBoxV2 from './elements/signature-box-v2';
import * as inputField from './elements/input-field';
import * as inputTextarea from './elements/input-textarea';
import * as numberInput from './elements/number-input';
import * as paymentFields from './elements/payment-fields';
import * as userNotice from './elements/user-notice';
import * as formSignList from './elements/form-sign-list';
import * as formSign from './elements/form-sign';
import * as grantSummary from './elements/grant-summary';
import * as currency from './value-converters/currency';
import * as date from './value-converters/date';
import * as humanize from './value-converters/humanize';
import * as fileSize from './value-converters/file-size';
import * as htmlCharacterEntity from './value-converters/html-character-entity';
import * as number from './value-converters/number';
import * as percentage from './value-converters/percentage';
import * as boolean from './value-converters/boolean';
import * as nullToEmptyString from './value-converters/nullToEmptyString';
import * as b64 from './value-converters/b64';
import * as padStart from './value-converters/pad-start';
import * as dateSmall from './value-converters/date-small';
import * as decimalCurrency from './value-converters/decimal-currency';

export const globalResources = [
  accessibleNames,
  addGroupItem,
  animateOnChange,
  applicantName,
  applicationDescription,
  applicationTag,
  datePicker,
  deleteGroupItem,
  deriveFromSsn,
  formField,
  gotoAnchor,
  multiply,
  popOverAttribute,
  submitApplication,
  sum,
  tooltip,
  attachment,
  attachmentV2,
  applicationLink,
  bankidSignature,
  popOverElement,
  textareaex,
  signatureBoxV2,
  inputField,
  inputTextarea,
  numberInput,
  paymentFields,
  userNotice,
  formSignList,
  formSign,
  grantSummary,
  currency,
  date,
  humanize,
  fileSize,
  htmlCharacterEntity,
  number,
  percentage,
  boolean,
  nullToEmptyString,
  b64,
  padStart,
  dateSmall,
  decimalCurrency,
];
